import PartnerDocumentsPanel from '@/components/PartnerDocumentsPanel';
import { StableTabsContent, StableTabsContentGroup } from '@/components/StableTabsContent';
import { Tabs } from '@chakra-ui/react';
import { ReactNode, useState } from 'react';
import { useI18n } from '@/i18n/I18nContext';

interface ProjectDetailTabsProps {
    projectId: number;
    children: ReactNode;
}

const ProjectDetailTabs = ({ projectId, children }: ProjectDetailTabsProps) => {
    const [activeTab, setActiveTab] = useState('details');
    const { t } = useI18n();

    return (
        <Tabs.Root
            value={activeTab}
            onValueChange={({ value }) => setActiveTab(value)}
        >
            <Tabs.List>
                <Tabs.Trigger value='details'>
                    {t('projects.details.tab')}
                </Tabs.Trigger>
                <Tabs.Trigger value='documents'>
                    {t('projects.details.documents')}
                </Tabs.Trigger>
            </Tabs.List>
            <StableTabsContentGroup>
                <StableTabsContent value='details' activeValue={activeTab}>
                    {children}
                </StableTabsContent>
                <StableTabsContent value='documents' activeValue={activeTab}>
                    <PartnerDocumentsPanel filters={{ projectId }} />
                </StableTabsContent>
            </StableTabsContentGroup>
        </Tabs.Root>
    );
};

export default ProjectDetailTabs;
